import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
    { path: '', loadChildren: './tabs/tabs.module#TabsPageModule' },
    { path: 'login', loadChildren: './login/login.module#LoginPageModule' },
    { path: 'login/:time', loadChildren: './login/login.module#LoginPageModule' },
    { path: 'webpage', loadChildren: './webpage/webpage.module#WebpagePageModule' },
    { path: 'aegHome', loadChildren: './aeg/home/home.module#HomePageModule' },
    { path: 'aegHome/:id', loadChildren: './aeg/home/home.module#HomePageModule' },
    { path: 'aegProductList', loadChildren: './aeg/product-list/product-list.module#ProductListPageModule' },
    { path: 'aegProductList/:id', loadChildren: './aeg/product-list/product-list.module#ProductListPageModule' },
    { path: 'aegAddProduct', loadChildren: './aeg/add-product/add-product.module#AddProductPageModule' },
    { path: 'aegAddProduct/:id', loadChildren: './aeg/add-product/add-product.module#AddProductPageModule' },
    { path: 'aegHistoryOrder', loadChildren: './aeg/history-order/history-order.module#HistoryOrderPageModule' },
    { path: 'aegHistoryOrder/:id', loadChildren: './aeg/history-order/history-order.module#HistoryOrderPageModule' },
    { path: 'aegHistoryOrderDetail', loadChildren: './aeg/history-order-detail/history-order-detail.module#HistoryOrderDetailPageModule' },
    { path: 'aegHistoryOrderDetail/:id', loadChildren: './aeg/history-order-detail/history-order-detail.module#HistoryOrderDetailPageModule' },
    { path: 'aegChangePassword', loadChildren: './aeg/change-password/change-password.module#ChangePasswordPageModule' },
    { path: 'noticePage', loadChildren: './aeg/notice/notice.module#NoticePageModule' },
    { path: 'noticePage/:id', loadChildren: './aeg/notice/notice.module#NoticePageModule' },
    { path: 'noticedetailPage', loadChildren: './aeg/notice-detail/notice-detail.module#NoticeDetailPageModule' },
    { path: 'noticedetailPage/:id', loadChildren: './aeg/notice-detail/notice-detail.module#NoticeDetailPageModule' }
];
@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
